import React, { PropTypes, PureComponent } from 'react';
import styles from './styles.scss';

export class Input extends PureComponent {
  /**
   * binds methods and initialises state
   * @param  {type} props passed to the component
   */
  constructor(props) {
    super(props);
    this.myOnChange = this.myOnChange.bind(this);
    this.myOnBlur = this.myOnBlur.bind(this);
    const { type, value } = props;

    let expression;
    switch (type) {
      case 'email':
        expression = /.*/;
        break;
      case 'password':
        expression = /^.{9,}$/;
        break;
      default:
        expression = /^.{1,}$/;
        break;
    }

    const showError = false;
    const valid = expression.test(value);
    this.state = { expression, showError, valid };
  }


  /**
   * executes when the value of the input is changed.
   * - validates the inputs value.
   * - calls the onChange function.
   * @param  {Function} onChange to be called on change.
   * @param  {Function} onValidation to be called on validation with validity of value
   * @param  {RegExp} expression to test the value against
   * @param  {String} value to be tested
   */
  myOnChange(onChange, onValidation, expression, valid, value) {
    if (value !== '' && expression.test(value)) {
      if (!valid) {
        this.setState({ valid: true });
        if (onValidation) {
          onValidation(true);
        }
      }
    } else if (valid) {
      this.setState({ valid: false });
      if (onValidation) {
        onValidation(false);
      }
    }
    if (onChange) {
      onChange(value);
    }
  }


  /**
   * sets showError if it should be...
   * @param  {Boolean} showError is used to determine whether errors are to be shown
   * @param  {String} value to be checked if exists
   */
  myOnBlur(showError, value, onBlur) {
    if (!showError) {
      this.setState({ showError: true });
    }
    if (onBlur) {
      onBlur(value);
    }
  }


  /**
   * @type {Component} input compontent, with validation.
   */
  render() {
    const {
      props, state, myOnChange, myOnBlur,
    } = this;
    const { expression, showError, valid } = state;
    const {
      onValidation,
      onBlur,
      className,
      onChange,
      type,
      value,
      placeholder,
      validOverwrite,
      disabled,
      layout,
      error,
      min,
    } = props;

    let borderError;
    if (showError && (!valid || validOverwrite === false) && error) {
      borderError = styles.errorBorder;
    }


    return (
      <div className={[layout, styles.view].join(' ').trim()}>
        <input
          className={[className, styles.input, borderError].join(' ').trim()}
          type={type}
          value={value}
          placeholder={placeholder}
          onBlur={() => myOnBlur(showError, value, onBlur)}
          onChange={event => myOnChange(
            onChange,
            onValidation,
            expression,
            valid,
            event.target.value,
          )}
          disabled={disabled}
          min={min}
        />
        <div className={styles.error}>
          <p className={styles.errorText}>
            {showError && (!valid || validOverwrite === false) ? error : null}
          </p>
        </div>
      </div>
    );
  }
}


/**
 * @type {Object} input properties
 */
Input.propTypes = {
  onValidation: PropTypes.func,
  className: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  showError: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  min: PropTypes.string,
  validOverwrite: PropTypes.bool,
};


/**
 * default export
 */
export default Input;


/*
  eslint
  no-useless-escape: 0,
*/



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/input/index.jsx